module.exports = __webpack_public_path__ + "static/img/activity-20240412.74f5d85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-20240412.png
// module id = pzz2
// module chunks = 0